import React, { useContext, useState } from "react";
import classes from "./FirstPW.module.scss";
import RoundButton from "../../../../components/Buttons/RoundButton";
import PageHeader from "../../../../components/Headers/PageHeader";
import PageMain from "../../../../components/Main/PageMain";
import InputText from "../../../../components/Inputs/InputText";
import PassWordValidations from "../../../../components/PassWordValidations";
import {
  checkAllValidations,
  checkPasswordValidations,
} from "../../../../helpers";
import * as d from "../../../../constants/defaults";
import * as r from "../../../../constants/routes";
import LoginContext from "../../../../context/loginContext";
import FriendlyInfo from "../../../../components/FriendlyInfo";
import { PASSWORD_TEMP_FAKE_CHANGE_EMPTY_STRING } from "../../../../constants/defaults";
import { useNavigate } from "react-router";

export default function FirstPW() {
  // #01 Hooks
  const context = useContext(LoginContext);
  const history = useNavigate();
  // #02 Reference
  // #03 States
  const [showForm, setShowForm] = useState(false);
  const [isPWVisible, setPWVisible] = useState(false);
  const [pass1, setPass1] = useState(PASSWORD_TEMP_FAKE_CHANGE_EMPTY_STRING);
  const [pass2, setPass2] = useState(PASSWORD_TEMP_FAKE_CHANGE_EMPTY_STRING);
  const [isSubmited, setIsSubmited] = useState(false);

  let _content = (
    <div className={classes.FirstPW}>
      <RoundButton
        title="Atualizar a senha"
        text={"Atualizar"}
        onClick={() => setShowForm(true)}
      />
    </div>
  );
  // fazer com que essa atualização de senha também torne o email_verified do cognito como true para poder mandar e-mail de confirmação de senha
  const updatePwHandler = (event: any, pw: string) => {
    setIsSubmited(true);
    if (checkAllValidations(pass1, pass2)) {
      context.completeLoginHandler({
        event,
        pw,
        history,
        route: r.R_A_USERS_LIST,
      });
    }
  };
  const startingPassword = pass1 !== "" || pass2 !== "";

  if (showForm) {
    _content = (
      <form
        action=""
        className={classes.FirstPW}
        onSubmit={(e: any) => {
          e.preventDefault();
          updatePwHandler(e, pass1);
        }}
      >
        {/* <InputText
          fake={true}
          label="ID da Empresa"
          alt="ID da Empresa"
          value={context.company_uid}
        /> */}
        <InputText
          label="Senha"
          alt="Cadastrar nova Senha"
          type={d.PASSWORD}
          value={pass1}
          onChange={setPass1}
          onClickShowPw={setPWVisible}
          showPw={isPWVisible}
          showPWIcon
        />

        <InputText
          label="Confirmar"
          alt="Confirmar nova Senha"
          type={d.PASSWORD}
          value={pass2}
          onChange={setPass2}
          onClickShowPw={setPWVisible}
          showPw={isPWVisible}
        />
        {startingPassword && (
          <>
            <RoundButton
              full
              type={d.SUBMIT}
              disabled={isSubmited}
              text="Salvar"
              title="Salvar nova senha"
            />
            <PassWordValidations
              {...checkPasswordValidations(pass1, pass2)}
            />
          </>
        )}
      </form>
    );
  }
  return (
    <>
      <div>
        <PageHeader
          title={"Bem-vindo!"}
          subtitle={"Para o primeiro acesso, atualize a sua senha"}
        />
        <PageMain center>
          <div className={classes.ChangeFirstPassword}>
            {_content}

          </div>
        </PageMain>
      </div>
    </>
  );
}
